import React, {useState} from 'react'
import {Icon} from '@therms/atalaya'
import {
  DateTime,
  SchedulingAssignmentTitle,
  ShiftActionsButtonGroup,
  ShiftInteractiveModal,
  ShiftProgressBar,
  ShiftStatusLabel,
  useCurrentUser,
  useRPCServerEventHandler,
  UserPosition,
  useUserCurrentOrFutureShift,
} from '@therms/react-modules'
import {MdOpenInNew} from 'react-icons/md'

function CurrentUserShiftStatusInteractiveCard() {
  const {id: userId} = useCurrentUser()
  const [showShiftModal, setShowShiftModal] = useState(false)

  const {data, refresh} = useUserCurrentOrFutureShift(userId)

  useRPCServerEventHandler('CurrentShiftsUpdated', (evt, {userIds}) => {
    if (userIds.includes(userId)) {
      refresh()
    }
  })

  const shift = data?.shift

  if (!shift) {
    return null
  }

  return (
    <div className="bg-surface-subtle rounded">
      {shift.status?.timeframe === 'future' && (
        <div className="px-sm py-xxs text-color-info rounded-t text-center text-sm font-bold italic">
          Upcoming shift
        </div>
      )}

      <div className="p-xs">
        <div className="inline-flex w-full justify-between">
          <div className="flex flex-col">
            {shift.title && <div className="font-medium">{shift.title}</div>}

            <SchedulingAssignmentTitle id={shift.assignmentId} />

            {shift.positionId && (
              <UserPosition id={shift.positionId} showColor />
            )}
          </div>
          <div
            className="text-color-main cursor-pointer"
            onClick={() => setShowShiftModal(true)}
          >
            <Icon size="sm" Icon={MdOpenInNew} />
          </div>
        </div>

        <div className="mt-xs">
          <ShiftProgressBar
            backgroundColor={shift.status?.color}
            className="grow rounded"
            startTime={shift.startTime}
            endTime={shift.endTime}
          >
            <div className="px-xxs grid grid-cols-2">
              <DateTime
                timestamp={shift.startTime}
                mode="time"
                toggleRelativeOnClick={false}
              />

              {shift.endTime ? (
                <DateTime
                  timestamp={shift.endTime}
                  mode="time"
                  toggleRelativeOnClick={false}
                />
              ) : (
                '--:--'
              )}
            </div>
          </ShiftProgressBar>

          {shift?.status && (
            <div className="mt-xs grid grid-cols-2 text-sm font-light">
              <ShiftStatusLabel shift={shift} />

              {shift.timeLogStatus?.timestamp ? (
                <DateTime relative timestamp={shift.timeLogStatus?.timestamp} />
              ) : null}
            </div>
          )}

          {shift && (
            <div className="mt-xs">
              <ShiftActionsButtonGroup shift={shift} />
            </div>
          )}
        </div>
      </div>

      {showShiftModal && (
        <ShiftInteractiveModal
          shiftId={shift.id}
          closeHandler={() => {
            setShowShiftModal(false)
            refresh()
          }}
        />
      )}
    </div>
  )
}

export {CurrentUserShiftStatusInteractiveCard}
